"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIItemSearchAPIResponseEntity = void 0;
const iclient_entity_1 = require("./iclient-entity");
const iplanning_item_entity_1 = require("./iplanning-item-entity");
function parseIItemSearchAPIResponseEntity(data) {
    if (data.planningItems !== null && typeof data.planningItems === 'object')
        data.planningItems = data.planningItems.map((x) => (0, iplanning_item_entity_1.parseIPlanningItemEntity)(x));
    if (data.clients !== null && typeof data.clients === 'object')
        data.clients = data.clients.map((x) => (0, iclient_entity_1.parseIClientEntity)(x));
    if (data.leads !== null && typeof data.leads === 'object')
        data.leads = data.leads.map((x) => (0, iclient_entity_1.parseIClientEntity)(x));
    return data;
}
exports.parseIItemSearchAPIResponseEntity = parseIItemSearchAPIResponseEntity;
